(function () {
  class Lantern extends PIXI.Container {
    constructor() {
      super();

      this.initialised = false;
      this.multiplierActive = false;

      const self = this;

      StateMachine.Create(this);

      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {});
      this.stateMachine.addState("INCREASEMULTIPLIER", function () {
        self.updateIncreaseMultiplier();
      });
      this.stateMachine.addState("RESET_MULTIPLIER", function () {
        self.updateResetMultiplier();
      });
      this.stateMachine.addState("BOOSTMULTIPLIER", function () {
        self.update_boostMultiplier();
      });

      this.resetMultiplierValues();

      this.currentStep = 0;
      this.targetStep = 0;
      this.boostTask = undefined;

      this.baseScales = [2, 1.4, 1];
      this.lengthScales = [1, 0.74, 0.62, 0.5, 0.38];
      this.shrinkPos = { x: 0, y: 0 };

      this.tweens = [];
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
      messageBus.subscribe("Game:boostMulti", this.boostMultiplier.bind(this));
    }

    onLayoutComplete() {
      var baseName = "lanternMultiplier:lantern:";

      this.multiplierDuplicate = resourceManager.get(
        baseName + "lanternDuplicate"
      );
      this.duplicatePos = {
        x: this.multiplierDuplicate.position.x,
        y: this.multiplierDuplicate.position.y,
      };
      this.multiplierDuplicateText = resourceManager.get(
        baseName + "lanternDuplicate:lanternDuplicateText"
      );

      this.multiplierBack = resourceManager.get(baseName + "lanternBack");
      this.backPos = {
        x: this.multiplierBack.position.x,
        y: this.multiplierBack.position.y,
      };
      this.multiplierBackText = resourceManager.get(
        baseName + "lanternBack:lanternBackText"
      );

      this.multiplierMid = resourceManager.get(baseName + "lanternMid");
      this.midPos = {
        x: this.multiplierMid.position.x,
        y: this.multiplierMid.position.y,
      };
      this.multiplierMidText = resourceManager.get(
        baseName + "lanternMid:lanternMidText"
      );

      this.multiplierAnim = resourceManager.get(baseName + "lanternAnimMovie");
      this.multiplierAnim.gotoAndStop(0);
      this.multiplierAnim.visible = true;

      this.multiplierFront = resourceManager.get(baseName + "lanternFront");
      this.frontPos = {
        x: this.multiplierFront.position.x,
        y: this.multiplierFront.position.y,
      };
      this.multiplierFrontText = resourceManager.get(
        baseName + "lanternFront:lanternFrontText"
      );

      this.dustEmitter = particleManager.createEmitter(
        "multiplierDustEmitterSmall",
        baseName + "particleContainer",
        0,
        0,
        false
      );
      this.dustEmitter.particleEmitter.emit = false;

      this.multiplierActive = false;

      this.onOrientationChange();

      this.setLayoutScaleFactor(this.multipliers);

      this.setupInitialScales();

      this.updateMultiplierText();

      this.addMessageListeners();
    }

    addMessageListeners() {
      messageBus.subscribe(
        "Game:ModifierEvent",
        this.hideMultipliers.bind(this)
      );
      messageBus.subscribe("Game:DropEvent", this.showMultipliers.bind(this));
      messageBus.subscribe(
        "Multipliers:ResetMultipliers",
        this.updateResetMultiplier.bind(this)
      );

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    setLayoutScaleFactor(multipliers) {
      this.frontScale =
        this.baseScales[0] * this.getMultiplierSize(multipliers[0]);
      this.midScale =
        this.baseScales[1] * this.getMultiplierSize(multipliers[1]);
      this.backScale =
        this.baseScales[2] * this.getMultiplierSize(multipliers[2]);
    }

    setupInitialScales() {
      this.multiplierDuplicate.scale.set(0);
      this.multiplierBack.scale.set(this.backScale);
      this.multiplierMid.scale.set(this.midScale);
      this.multiplierFront.scale.set(this.frontScale);

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
    }

    setupInitialScales() {
      this.multiplierDuplicate.scale.set(0);
      this.multiplierBack.scale.set(this.backScale);
      this.multiplierMid.scale.set(this.midScale);
      this.multiplierFront.scale.set(this.frontScale);

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
    }

    setMultiplierPositions() {
      this.multiplierDuplicate.position.set(
        this.duplicatePos.x,
        this.duplicatePos.y
      );
      this.multiplierBack.position.set(this.backPos.x, this.backPos.y);
      this.multiplierMid.position.set(this.midPos.x, this.midPos.y);
      this.multiplierFront.position.set(this.frontPos.x, this.frontPos.y);
    }

    moveAndScale(noAnim) {
      soundManager.play("multiplierIncrease");

      // if (noAnim) {
      // soundManager.play("explode" + Math.floor(Math.random() * 3));
      // } else {
      // soundManager.play("winMultiplied");
      // }

      var duration = 0.4;
      var newBackScale =
        this.baseScales[2] * this.getMultiplierSize(this.multipliers[3]);
      var newMidScale =
        this.baseScales[1] * this.getMultiplierSize(this.multipliers[2]);
      var newFrontScale =
        this.baseScales[0] * this.getMultiplierSize(this.multipliers[1]);

      this.tweens.push(
        gsap.to(this.multiplierFront, {
          duration,
          x: this.shrinkPos.x,
          y: this.shrinkPos.y,
        }),
        gsap.to(this.multiplierFront.scale, {
          duration,
          x: 0,
          y: 0,
        }),
        gsap.to(this.multiplierMid, {
          duration,
          x: this.frontPos.x,
          y: this.frontPos.y,
        }),
        gsap.to(this.multiplierMid.scale, {
          duration,
          x: newFrontScale,
          y: newFrontScale,
        }),
        gsap.to(this.multiplierBack, {
          duration,
          x: this.midPos.x,
          y: this.midPos.y,
        }),
        gsap.to(this.multiplierBack.scale, {
          duration,
          x: newMidScale,
          y: newMidScale,
        }),
        gsap.to(this.multiplierDuplicate, {
          duration,
          x: this.backPos.x,
          y: this.backPos.y,
        }),
        gsap.to(this.multiplierDuplicate.scale, {
          duration,
          x: newBackScale,
          y: newBackScale,
          onComplete: () => {
            this.moveAndScaleComplete(noAnim);
          },
        })
      );
    }

    moveAndScaleComplete(noAnim) {
      this.incrementMultipliers();
      this.updateMultiplierText();
      this.setFinalScaleAndPosition();
      this.onOrientationChange();

      this.multiplierFront.visible = true;

      if (!noAnim) {
        this.multiplierAnim.gotoAndPlay(0);
      }
    }

    setFinalScaleAndPosition() {
      this.setMultiplierPositions(
        this.frontPos,
        this.midPos,
        this.backPos,
        this.duplicatePos
      );

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
    }

    getMultiplierSize(multiplier) {
      if (multiplier < 10) {
        return this.lengthScales[0];
      } else if (multiplier < 100) {
        return this.lengthScales[1];
      } else if (multiplier < 1000) {
        return this.lengthScales[2];
      } else if (multiplier < 10000) {
        return this.lengthScales[3];
      } else {
        return this.lengthScales[4];
      }
    }

    resetMultiplierValues() {
      this.multipliers = [1, 2, 4, 8]; // front, middle, back, duplicate
    }

    getCurrentMultiplier() {
      return this.multipliers[0];
    }

    resetMultiplier() {
      this.stateMachine.switchState("RESET_MULTIPLIER");
    }

    hideMultipliers() {
      this.multiplierDuplicate.visible = false;
      this.multiplierBack.visible = false;
      this.multiplierMid.visible = false;
      this.multiplierFront.visible = false;
    }

    showMultipliers() {
      this.multiplierDuplicate.visible = true;
      this.multiplierBack.visible = true;
      this.multiplierMid.visible = true;
      this.multiplierFront.visible = true;
    }

    increaseMultiplier() {
      this.stateMachine.switchState("INCREASEMULTIPLIER");
      this.multiplierActive = true;
    }

    closeDoor() {
      if (this.multiplierActive) {
        this.stateMachine.switchState("CLOSEMULTIPLIER");
      }
    }

    updateMultiplierText() {
      this.multiplierDuplicateText.text = "X" + this.multipliers[3];
      this.multiplierBackText.text = "X" + this.multipliers[2];
      this.multiplierMidText.text = "X" + this.multipliers[1];
      this.multiplierFrontText.text = "X" + this.multipliers[0];

      this.setLayoutScaleFactor(this.multipliers);
    }

    setMultiplierScale(frontScale, midScale, backScale) {
      this.multiplierDuplicate.scale.set(0);

      this.multiplierBack.scale.set(backScale);

      this.multiplierMid.scale.set(midScale);

      this.multiplierFront.scale.set(frontScale);
    }

    incrementMultipliers() {
      for (let i = 0; i < this.multipliers.length; i++) {
        this.multipliers[i] = this.multipliers[i] * 2;
      }
    }

    updateIncreaseMultiplier() {
      if (this.phase.enter()) {
        this.multiplierActive = true;
        this.pulseMultiplierWinTxtTween();
      }

      if (this.phase.timed(1500)) {
      }

      if (this.phase.once()) {
        this.moveAndScale();
      }

      if (this.phase.timed(1000)) {
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("IDLE");
      }
    }

    boostMultiplier(task) {
      this.boostTask = task.join();

      this.currentStep = 0;
      this.targetStep = task.data.multiSteps;

      this.stateMachine.switchState("BOOSTMULTIPLIER");
    }

    update_boostMultiplier() {
      if (this.phase.enter()) {
      }

      // we move the boost overlay from the wild symbol to the multiplier display for each boost
      // and only on the last one is it removed leaving a wild symbol displayed.
      if (this.phase.once()) {
        let lastBoost = this.currentStep === this.targetStep - 1;
        resourceManager
          .get("wildSymbolAnimator:wildSymbolAnimator")
          .moveBoostWild(lastBoost);
      }

      if (this.phase.hold()) {
        if (
          !resourceManager
            .get("wildSymbolAnimator:wildSymbolAnimator")
            .wildsActive()
        ) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        let lastBoost = this.currentStep === this.targetStep - 1;
        this.moveAndScale(!lastBoost);

        this.dustEmitter.particleEmitter.emit = true;
        this.multiplierFront.visible = false;
      }

      if (this.phase.timed(500)) {
      }

      if (this.phase.once()) {
        this.currentStep++;

        if (this.currentStep < this.targetStep) {
          this.phase.reset();
        }
      }

      if (this.phase.timed(250)) {
      }

      if (this.phase.once()) {
        this.boostTask.leave();
        this.boostTask = undefined;

        this.currentStep = 0;
        this.targetStep = 0;

        this.stateMachine.switchState("IDLE");
      }
    }

    updateResetMultiplier() {
      if (this.phase.enter()) {
        if (!this.multiplierActive) {
          this.stateMachine.switchState("IDLE");
          return;
        }

        soundManager.play("multiplierReset");
      }

      if (this.phase.timed(200)) {
        let newFrontScale = this.frontScale * (1 - this.phase.Progress);
        let newMidScale = this.midScale * (1 - this.phase.Progress);
        let newBackScale = this.backScale * (1 - this.phase.Progress);

        this.setMultiplierScale(newFrontScale, newMidScale, newBackScale);
      }

      if (this.phase.timed(100)) {
      }

      if (this.phase.once()) {
        this.resetMultiplierValues();
        this.updateMultiplierText();
        this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
      }

      if (this.phase.timed(200)) {
        this.setLayoutScaleFactor(this.multipliers);

        let frontScaleIn = this.frontScale * this.phase.Progress;
        let midScaleIn = this.midScale * this.phase.Progress;
        let backScaleIn = this.backScale * this.phase.Progress;

        this.setMultiplierScale(frontScaleIn, midScaleIn, backScaleIn);
      }

      if (this.phase.once()) {
        let frontScale = this.frontScale;
        let midScale = this.midScale;
        let backScale = this.backScale;

        this.setMultiplierScale(frontScale, midScale, backScale);

        this.multiplierActive = false;
        this.stateMachine.switchState("IDLE");
      }
    }

    pulseMultiplierWinTxtTween() {
      soundManager.play("multiplierHighlight");

      gsap.to(this.multiplierFront.scale, {
        duration: 0.15,
        ease: "linear",
        x: this.frontScale * 1.4,
        y: this.frontScale * 1.4,
        yoyo: true,
        repeat: 3,
      });
    }

    onOrientationChange() {
      this.frontPos = { x: this.multiplierFront.x, y: this.multiplierFront.y };
      this.midPos = { x: this.multiplierMid.x, y: this.multiplierMid.y };
      this.backPos = { x: this.multiplierBack.x, y: this.multiplierBack.y };
      this.duplicatePos = {
        x: this.multiplierDuplicate.x,
        y: this.multiplierDuplicate.y,
      };

      if (systemData.isLandscape) {
        this.shrinkPos = { x: this.frontPos.x, y: this.frontPos.y + 120 };
      } else {
        this.shrinkPos = { x: this.frontPos.x + 120, y: this.frontPos.y };
      }

      this.tweens.forEach((i) => {
        i.progress(1);
        return;
      });

      this.setLayoutScaleFactor(this.multipliers);

      this.setupInitialScales();
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }
  }

  create = function (json) {
    return new Lantern();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "lantern",
    create,
    initialise,
    getFilesRequired
  );
})();
